import { ApplicationConfig, provideZonelessChangeDetection, isDevMode, provideAppInitializer, inject } from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';

import { routes } from './app.routes';
import { provideHttpClient, withInterceptors, withXhr } from '@angular/common/http';
import { authInterceptor } from '@auth/interceptor/auth.interceptor';
import { errorInterceptor } from '@auth/interceptor/error.interceptor';
import { xsrfInterceptor } from '@auth/interceptor/xsrf.interceptor';
import { provideServiceWorker } from '@angular/service-worker';
import { UpdateServiceWorkerService } from './update-service-worker.service';
import { PreloadConfigService } from '@common/config/preload-config.service';
import { environment } from '../environments/environment';
import { KioskAutoReloadService } from '@common/services/kiosk-auto-reload.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZonelessChangeDetection(),
    provideRouter(routes, withComponentInputBinding()),
    provideHttpClient(withXhr(), 
      withInterceptors([
        xsrfInterceptor,
        authInterceptor,
        errorInterceptor,
      ])
    ),
    // provideAppInitializer(async () => {
    //   const config = inject(PreloadConfigService);
    //   await config.load();
    //   config.initializeDerivedSignals();
    // }),

    provideAppInitializer(() => inject(PreloadConfigService).load()),
    provideAppInitializer(() => {
      const isKiosk = (environment as { isKiosk?: boolean }).isKiosk === true;
      if (!isKiosk) return;
      inject(KioskAutoReloadService).start();
    }),

    provideServiceWorker('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000'
    }),
    UpdateServiceWorkerService, // Servicio para gestionar las actualizaciones del service worker
  ]
};
